export default [
  {
    for: 'article',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'artist',
    actions: {
      create: true,
      update: true,
      read: true,
    },
    excludedProperties: ['text'],
  },
  {
    for: 'asset',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'audioplayer',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'channel',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'collection',
    actions: {
      create: true,
      update: true,
      read: true,
    },
    excludedProperties: ['text'],
  },
  {
    for: 'calendar-event',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'live-event',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'media-event',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'media-embed',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'person',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'product',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'short-url',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'teaser',
    actions: {
      create: true,
      update: true,
      read: true,
    },
    excludedProperties: ['youniverseStageAssets', 'youniverseScreenAssets'],
  },
  {
    for: 'story',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'link',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
];
